import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from '../copysource/store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from '../copysource/format-read-settings/format-read-settings.util';
import { OrcSink } from 'app/model/pipeline/copysink/orc.sink';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OrcSink),
    asynchronous: true,
    adapts: {
        type: '*',
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class OrcSinkAdapter extends CopySinkAdapter<OrcSink, Model.OrcSink> {
    protected override async _toResource(model: OrcSink): Promise<Model.OrcSink> {
        const result: Model.OrcSink = {
            type: OrcSink.MODEL.name
        };

        await convertStoreSettingsToResource(model.storeSettings, result, this.context);
        await convertFormatSettingsToResource(model.formatSettings, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.OrcSink, owner: Activity): Promise<OrcSink> {
        const result = Owned.create<OrcSink>(Metamodel.modelFor(OrcSink), owner);

        await convertStoreSettingsToModel(resource.storeSettings, result, this.context);
        await convertFormatSettingsToModel(resource.formatSettings, result, this.context);

        return result;
    }
}
